module.exports = __webpack_public_path__ + "img/trash_yellow.6d039866.svg";